import React from 'react';
import {Typography} from "@mui/material";
import BottomBorder from "../BottomBorder";
import {AiMentionsTwoMinutesContent} from "../../models/AiMentionsContent";

interface ZigzagProps {
    content: AiMentionsTwoMinutesContent;
}

// SEO and AI Mentions as two layers of the same thing - the visual half carries
// the argument, the text half explains it.
const Zigzag: React.FC<ZigzagProps> = ({content}) => (
    <section className="lnk-aim__zig">
        <div className="lnk-aim__wrap lnk-aim__zig-grid">
            <div>
                <div className="lnk-aim__zig-boxes">
                    <div className="lnk-aim__zbox lnk-aim__zbox--light">
                        <div className="lnk-aim__zbox-kicker">הבסיס</div>
                        <div className="lnk-aim__zbox-title">SEO</div>
                        <div className="lnk-aim__zbox-sub">להיות בחיפוש</div>
                    </div>
                    <div className="lnk-aim__plus" aria-hidden="true">+</div>
                    <div className="lnk-aim__zbox lnk-aim__zbox--brand">
                        <div className="lnk-aim__zbox-kicker">החדש</div>
                        <div className="lnk-aim__zbox-title">AI Mentions</div>
                        <div className="lnk-aim__zbox-sub">להיות בתשובה</div>
                    </div>
                </div>
                <p className="lnk-aim__zig-caption">{content.caption}</p>
            </div>

            <div className="lnk-aim__zig-text">
                <div className="lnk-aim__title-block">
                    <Typography variant="h2">{content.title}</Typography>
                    <BottomBorder width={69} addMargin={false}/>
                </div>
                {/* pre-line: an Enter in the admin's textarea is a line break here */}
                <p style={{whiteSpace: "pre-line"}}>{content.body}</p>
            </div>
        </div>
    </section>
);

export default Zigzag;
